import { render, staticRenderFns } from "./BulkQoutAllOperation.vue?vue&type=template&id=2c018904&scoped=true"
import script from "./BulkQoutAllOperation.vue?vue&type=script&lang=ts"
export * from "./BulkQoutAllOperation.vue?vue&type=script&lang=ts"
import style0 from "./BulkQoutAllOperation.vue?vue&type=style&index=0&id=2c018904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c018904",
  null
  
)

export default component.exports